<div
  class="card side-entity-card"
  [class.pa-history-read-only]="isPaHistoryReadOnly()"
  [style.height]="containerHeight"
  [ngStyle]="componentColourStyles">

  <!-- Drag handle: resizes the form panel against the table widget -->
  <div class="panel-resize-handle"
       title="Drag to resize"
       (pointerdown)="onResizeHandlePointerDown($event)">
    <div class="panel-resize-grip"></div>
  </div>

  <div class="loading-overlay" *ngIf="loading || isSaving">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <ng-container *ngIf="editableRecord; else noRecord">
    <div class="form-section form-section--main">
      <div class="section-header" (click)="data.sections[0].isExpanded = !data.sections[0].isExpanded">
        <span>{{ sectionTitle }}</span>
        <mat-icon>{{ data.sections[0].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      <div
        class="section-content"
        *ngIf="data.sections[0].isExpanded"
        [attr.inert]="isPaHistoryReadOnly() ? '' : null">
        <div *ngFor="let field of formFields" class="form-row">
          <label class="form-label">{{ field.label }}</label>

          <!-- Quote Yes/No dropdown -->
          <mat-form-field *ngIf="isQuoteYesNoField(field.key)" appearance="outline" class="form-field quote-yes-no-field">
            <mat-select
              [value]="getQuoteYesNoSelectedValue(field.key)"
              [disabled]="isFieldReadonly(field)"
              (selectionChange)="onFieldValueChange(field.key, $event.value)">
              <mat-option *ngFor="let option of getQuoteYesNoOptions(field.key)" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Dropdown -->
          <div *ngIf="isQuoteDetailPartNumberField(field.key)" class="domain-field-group part-number-field-group">
            <mat-form-field appearance="outline" class="form-field domain-select-field">
              <input
                matInput
                readonly
                [value]="getFieldDisplayLabelForField(field.key)"
                [disabled]="isFieldReadonly(field)">
            </mat-form-field>
            <button type="button" class="domain-action-button edit-domain-button" aria-label="Select Part Number" matTooltip="Select Part Number" [disabled]="isFieldReadonly(field)" (click)="openPartNumberPopup($event, field.key)">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="domain-action-button clear-domain-button" aria-label="Clear selection" matTooltip="Clear" [disabled]="isFieldReadonly(field)" (click)="clearFieldDropdown(field.key)">
              <mat-icon>close</mat-icon>
            </button>
            <button type="button" class="domain-action-button reference-domain-button" aria-label="Reference entity" [matTooltip]="getDomainReferenceTooltip(field.key)" matTooltipClass="side-entity-reference-tooltip" (click)="navigateToDomainReference(field.key)">
              <mat-icon>apps</mat-icon>
            </button>
          </div>

          <div *ngIf="!isQuoteYesNoField(field.key) && !isIconOnlyActionField(field.key) && !isQuoteDetailPartNumberField(field.key) && hasFieldDropdown(field.key)" class="domain-field-group">
            <mat-form-field appearance="outline" class="form-field domain-select-field">
              <mat-select
                panelClass="side-entity-domain-select-panel"
                [value]="getSelectedDomainFieldValue(field.key)"
                [compareWith]="compareFieldDropdownValues"
                [disabled]="isFieldReadonly(field)"
                (openedChange)="onDomainSelectOpened(field.key, $event)"
                (selectionChange)="onFieldDropdownSelectionChange(field.key, $event.value)">
                <mat-select-trigger>
                  {{ getFieldDisplayLabel(field.key) || '--Select--' }}
                </mat-select-trigger>
                <mat-option class="domain-search-option" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                  <input
                    class="domain-search-input"
                    type="text"
                    placeholder="Search"
                    [value]="getFieldDropdownSearchTerm(field.key)"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    (keyup)="$event.stopPropagation()"
                    (input)="setFieldDropdownSearchTerm(field.key, $any($event.target).value)">
                </mat-option>
                <mat-option class="domain-placeholder-option" [value]="null">--Select--</mat-option>
                <mat-option *ngIf="fieldDropdownLoading[field.key]" disabled>Loading...</mat-option>
                <mat-option *ngFor="let option of getFilteredFieldDropdownOptions(field.key)" [value]="getFieldDropdownValueForField(field.key, option)">
                  {{ getFieldDropdownLabel(option) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button type="button" class="domain-action-button clear-domain-button" aria-label="Clear selection" matTooltip="Clear" [disabled]="isFieldReadonly(field)" (click)="clearFieldDropdown(field.key)">
              <mat-icon>close</mat-icon>
            </button>
            <button type="button" class="domain-action-button reference-domain-button" aria-label="Reference entity" [matTooltip]="getDomainReferenceTooltip(field.key)" matTooltipClass="side-entity-reference-tooltip" (click)="navigateToDomainReference(field.key)">
              <mat-icon>apps</mat-icon>
            </button>
          </div>

          <!-- Date picker -->
          <mat-form-field *ngIf="!isQuoteYesNoField(field.key) && !isIconOnlyActionField(field.key) && !isQuoteDetailPartNumberField(field.key) && !hasFieldDropdown(field.key) && isDateField(field.key)" appearance="outline" class="form-field date-field">
            <input matInput [matDatepicker]="picker"
                   [value]="getDateValue(editableRecord[field.key])"
                   [disabled]="isFieldReadonly(field)"
                   (dateInput)="onDateValueChange(field.key, $event.value)"
                   (dateChange)="onDateValueChange(field.key, $event.value)"
                   (input)="onDateInputMask(field.key, $event)"
                   inputmode="numeric"
                   maxlength="10"
                   placeholder="MM/DD/YYYY">
            <mat-datepicker-toggle matIconSuffix [for]="picker" class="date-toggle" [disabled]="isFieldReadonly(field)">
              <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <!-- Icon-only table action -->
          <div *ngIf="isIconOnlyActionField(field.key)" class="form-icon-only-control">
            <button
              type="button"
              mat-icon-button
              class="quote-field-eye-button"
              [attr.aria-label]="getIconOnlyActionLabel(field.key)"
              [matTooltip]="getIconOnlyActionLabel(field.key)"
              (click)="openIconOnlyFieldAction($event, field.key)">
              <mat-icon>{{ getIconOnlyActionIcon(field.key) }}</mat-icon>
            </button>
          </div>

          <!-- Text input -->
          <mat-form-field *ngIf="!isQuoteYesNoField(field.key) && !isIconOnlyActionField(field.key) && !isQuoteDetailPartNumberField(field.key) && !hasFieldDropdown(field.key) && !isDateField(field.key)" appearance="outline" class="form-field">
            <input matInput [ngModel]="formatFieldValueForField(field.key, editableRecord[field.key])" [disabled]="isFieldReadonly(field)" (ngModelChange)="onFieldValueChange(field.key, $event)">
          </mat-form-field>
        </div>
      </div>

      <div class="form-actions" *ngIf="data.sections[0].isExpanded">
        <hr class="divider" />
        <div class="action-buttons-container">
          <button
            *ngFor="let action of data.sections[0].actions"
            mat-flat-button
            [class]="action.style"
            (click)="handleAction(action.actionId)"
            [disabled]="isFormActionDisabled(action)">
            {{ action.label }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-section" *ngIf="data.sections[1]">
      <div class="section-header" (click)="data.sections[1].isExpanded = !data.sections[1].isExpanded">
        <span>{{ data.sections[1].title }}</span>
        <mat-icon>{{ data.sections[1].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
      <div class="section-content" *ngIf="data.sections[1].isExpanded">
        <p>Related entities content placeholder.</p>
      </div>
    </div>
  </ng-container>

  <ng-template #noRecord>
    <div *ngIf="!loading" class="no-record-message"></div>
  </ng-template>

</div>

<ng-template #partNumberDialog>
  <section class="part-number-dialog" aria-labelledby="part-number-dialog-title">
    <header class="part-number-dialog-header">
      <h2 id="part-number-dialog-title">Select Items</h2>
      <div class="part-number-dialog-header-actions">
        <button type="button" class="part-number-dialog-header-button" aria-label="Filter Part Numbers" matTooltip="Filter" (click)="openPartNumberFilterPopup($event)">
          <mat-icon>filter_list</mat-icon>
        </button>
        <button
          type="button"
          class="part-number-dialog-header-button"
          [class.part-number-dialog-header-button--muted]="!hasPartNumberFilterApplied()"
          aria-label="Clear Part Number Filter"
          matTooltip="Clear Filter"
          (click)="clearPartNumberFilter($event)">
          <mat-icon class="material-symbols-outlined">filter_list_off</mat-icon>
        </button>
        <button type="button" class="part-number-dialog-header-button" aria-label="Close Select Items" matTooltip="Close" (click)="cancelPartNumberSelection()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>

    <div class="part-number-table-wrap">
      <table class="part-number-table">
        <thead>
          <tr>
            <th scope="col">Code</th>
            <th scope="col">Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="fieldDropdownLoading[activePartNumberFieldKey]">
            <td colspan="2" class="part-number-table-message">Loading items...</td>
          </tr>
          <tr
            *ngFor="let option of getPartNumberVisibleOptions(); trackBy: trackByPartNumberOption"
            class="part-number-option-row"
            tabindex="0"
            role="button"
            [class.selected]="isPartNumberOptionSelected(option)"
            [attr.aria-selected]="isPartNumberOptionSelected(option)"
            (click)="selectPartNumberOption(option)"
            (keydown.enter)="selectPartNumberOption(option)"
            (keydown.space)="$event.preventDefault(); selectPartNumberOption(option)">
            <td>{{ getPartNumberOptionCode(option) }}</td>
            <td>{{ getPartNumberOptionName(option) }}</td>
          </tr>
          <tr *ngIf="!fieldDropdownLoading[activePartNumberFieldKey] && partNumberTotalRows === 0">
            <td colspan="2" class="part-number-table-message">No items available.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="part-number-pagination" *ngIf="!fieldDropdownLoading[activePartNumberFieldKey] && partNumberTotalRows > 0">
      <span>Rows: {{ partNumberTotalRows }} | Page Size: {{ partNumberPageSize }} | Current Page: {{ partNumberCurrentPage }}</span>
      <div class="part-number-page-controls" aria-label="Part Number table pagination">
        <button type="button" aria-label="First page" [disabled]="partNumberCurrentPage === 1" (click)="goToPartNumberPage(1)">
          <mat-icon>first_page</mat-icon>
        </button>
        <button type="button" aria-label="Previous page" [disabled]="partNumberCurrentPage === 1" (click)="goToPartNumberPage(partNumberCurrentPage - 1)">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          *ngFor="let page of getPartNumberPageNumbers()"
          type="button"
          class="part-number-page-number"
          [class.active]="page === partNumberCurrentPage"
          [attr.aria-label]="'Page ' + page"
          [attr.aria-current]="page === partNumberCurrentPage ? 'page' : null"
          (click)="goToPartNumberPage(page)">
          {{ page }}
        </button>
        <button type="button" aria-label="Next page" [disabled]="!partNumberHasNextPage" (click)="goToPartNumberPage(partNumberCurrentPage + 1)">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>

    <footer class="part-number-dialog-footer">
      <button type="button" class="part-number-submit" [disabled]="!pendingPartNumberOption" (click)="submitPartNumberSelection()">Submit</button>
      <button type="button" class="part-number-cancel" (click)="cancelPartNumberSelection()">Cancel</button>
    </footer>
  </section>
</ng-template>
